module.exports = __webpack_public_path__ + "static/media/bank-shield-mask.5db48336.png";